import { HttpService } from "@/core";
import {
  makeInvoicePageRep,
  makeInvoicePageResp,
  makeInvoiceReq,
  makeInvoiceDetailResp,
  paymentReq,
  paymentPageResp,
  receiptReq,
} from "./makeTicket.interface";
import { detailResp, ExportReq, ExportResp } from "@/core/interface";
import { LogDetailResp } from "@/views/work-manage/log/log.interface";

export class makeInvoiceService {
  static usePageApi() {
    const api = (params: makeInvoicePageRep) =>
      HttpService.axios({
        method: "GET",
        url: "/make_invoice/page",
        params,
      });
    return HttpService.usePagination<makeInvoicePageResp>(api);
  }

  static useCreateApi() {
    const api = (data: makeInvoiceReq) =>
      HttpService.axios({
        method: "POST",
        url: "/make_invoice/add",
        data,
      });
    return HttpService.useRequest<detailResp>(api);
  }

  static useEditApi() {
    const api = (id: string, data: makeInvoiceReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/make_invoice/update/${id}`,
        data,
      });
    return HttpService.useRequest<detailResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/make_invoice/${id}`,
      });
    return HttpService.useRequest<makeInvoiceDetailResp>(api);
  }

  static useExportApi() {
    const api = (params: ExportReq) =>
      HttpService.axios({
        method: "GET",
        url: `/make_invoice/export`,
        params,
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }

  static paymentPage() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: `/receipt_access/getWriteenOffDetailList`,
        params,
      });
    return HttpService.usePagination<paymentPageResp>(api);
  }

  static receiptList() {
    const api = (contractId) =>
      HttpService.axios({
        method: "GET",
        url: `/receipt_access/selectList/${contractId}`,
      });
    return HttpService.usePagination<receiptReq>(api);
  }
}
